<!--suppress ALL -->

<template>
  <el-dialog top="10px" :title="inputTitle" :visible.sync="isVisible" width="98%" :close-on-click-modal="true"
             :close-on-press-escape="false" :fullscreen="false" footer-hide>


    <el-row :gutter=0>
      <el-col :span="5">
        <div style="border-right: 1px solid lightgray; height: 100vh; ">
          <div>
            <!--            <el-radio-group @change="changeGroup" v-model="chat_group_id" size="mini" >-->
            <!--              <el-radio-button v-for="(item,index) in chat_groups" :key="index" :label="item.itemId">{{item.title}}</el-radio-button>-->
            <!--            </el-radio-group>-->
            <div
                style="margin-bottom: 10px; margin-left: 5px; margin-right: 10px; color: black; border-radius: 4px; padding: 10px"
                :style="{'background':item.itemId === chat_group_id ?'#E7E7E7':'#fafafa'}"
                v-for="(item,index) in chat_groups" :key="index" @click="changeGroup(item)">{{ item.title }}
            </div>

            <el-button type="text" size="mini" style="margin-left: 10px" @click="createChatGroup">+添加新对话</el-button>
          </div>

        </div>
      </el-col>
      <el-col :span="19">


        <div class="message-list" ref="messageList">
          <div v-for="message in messages" :key="message.id"
               :class="['message', message.type === 'me' ? 'mine' : 'other']">
            <div v-if="message.type === 'me'" class="content" :style="{ marginRight: '10px' }">
              <vue-markdown class="" :source="message.content"></vue-markdown>
            </div>
            <img v-if="message.type === 'me'" class="avatar" :src="message.avatar" :style="{ top: '0', }" alt="Avatar">
            <img v-if="message.type === 'other'" class="avatar" :src="message.avatar" alt="Avatar">
            <!--          <div v-if="message.type === 'other'" class="content">{{ message.content }}</div>-->

            <div v-if="message.type === 'other'">
              <vue-markdown class="content" :source="message.content"></vue-markdown>
              <div style="color: darkgray; font-size: 13px; margin: 3px;" @click="copy(message.content)">复制</div>
            </div>
          </div>

        </div>

        <div v-if="!agent.params">
          <div
              style="width: 97%; height: 40px; margin-top: 0px; padding-top: 10px; padding-left: 20px; border-top: 1px solid lightgray; display: flex">
            <!--          <img src="@/assets/icon/folder.png" width="25px" height="25px"/>-->
            <file-upload style=""
                         @upload-success="fileUploadSuccess" :origin-file-require="false"
                         custom-icon="/assets/icon/folder.png"
                         :hide-name-view="true"></file-upload>
            <img src="@/assets/icon/micro.png" width="22px" height="22px" style="margin-left: 20px"
                 @click="startRecording"/>

            <el-button style="margin-left: 50px; height: 30px; color: white; background: red; border: 0px" size="small"
                       v-if="recording" @click="stopRecording">
              结束语音
            </el-button>

            <img src="@/assets/icon/note.png" width="22px" height="22px" style="margin-left: 20px"
                 @click="templateAction"/>

            <img src="@/assets/icon/power.png" width="22x" height="22px" style="margin-left: 20px"
                 @click="isVisible = false"/>

            <el-button style="margin-left: 50px; height: 30px; color: white; background: #6499ea; border: 0px" size="small"
                       v-if="isStream" @click="stopStream">
              停止生成
            </el-button>


            <el-select @change="changeAgent" style="width: 200px; margin-left: 30px" placeholder="指定数字员工"
                       v-if="agent.agentOptions && agent.agentOptions.length > 0" v-model="select_agent_id" size="small"
                       class="full">
              <el-option v-for="item in agent.agentOptions" :value="item.itemId+''" :key="item.itemId"
                         :label="item.title"></el-option>
            </el-select>

            <div style="display: flex">
              <div v-for="(item,index) in file_urls" :key="index"
                   style="margin-left: 20px; font-size: 12px; background: #f8f8f8; border-radius: 3px;padding-left:4px; padding-right: 4px">
                {{ item.name }}
                <el-button size="small" type="text" @click="deleteFileUrl(index)">删除</el-button>
              </div>
            </div>

          </div>
          <textarea type="textarea"
                    style=" background: #f8f8f8; height: 100px; padding: 10px; padding-left: 20px; font-size: 16px; width: 95%; margin-top: 0px; border: 0px"
                    placeholder="输入提示词" v-model="inputValue" @input="onInput" @keyup.enter="sendMessage"
          ></textarea>
        </div>


        <div v-if="agent.params" class="" style="display: flex; flex-wrap: wrap; padding-left: 10px; margin-top: 10px">
          <div v-for="(item,index) in agent.params" :key="index" style="margin-bottom: 15px">
            <span class="name">{{ item.label }}:</span>
            <el-input v-model="item.value" style="width: 200px; margin-left: 10px; margin-right: 20px"/>
          </div>
          <el-button class="send-button" size="small" style="margin-left: 10px; height: 40px" @click="getAiData">确定
          </el-button>
        </div>


        <product-display ref="productDisplay"></product-display>
        <template-pick ref="templatePick" @refresh="templateInfo"></template-pick>
        <chat-group-add ref="chatGroupAdd" @refresh="getChatGroup"></chat-group-add>


      </el-col>
    </el-row>


  </el-dialog>
</template>

<script>

import VueMarkdown from 'vue-markdown'
import Vue from 'vue';
import Recorder from 'js-audio-recorder'
import ProductDisplay from '../app/product_display'
import TemplatePick from './template_pick'
import ChatGroupAdd from './chat_group_add'
import Log from "@/components/Log"
import wx from "weixin-js-sdk";

export default {
  name: 'Profile',
  data() {
    return {
      agentItemId: 0,
      select_agent_id: '',
      agent: {},
      recorder: null,
      recording: false,
      inputTitle: '',
      isVisible: false,
      viewType: 'chat',
      chat_groups: [],
      chat_group_id: 0,
      chat_group_title: '',

      file_urls: [],

      isStream: false,
      eventSource: null,


      messages: [
        // {
        //   id: 1,
        //   type: 'me',
        //   content: '你好',
        //   avatar: 'https://cdn.haohuatech.cn/20241111/29b445fcaf9d940b0e6a70586c9c2eb5-731293763407773743.jpeg'
        // },
        // {
        //   id: 2,
        //   type: 'other',
        //   content: '你好，有什么可以帮您的吗？',
        //   avatar: 'https://cdn.haohuatech.cn/20241111/bd1d3135e571e0b9024e491e5589b60a-731293799623406342.jpeg'
        // }
      ],
      inputValue: '',


    }
  },
  mounted() {
    //document.addEventListener('click', this.handleClick, true);
  },
  beforeDestroy() {
    //document.removeEventListener('click', this.handleClick, true);
  },
  created: function () {
  },
  components: {
    TemplatePick,
    VueMarkdown, ProductDisplay, TemplatePick, ChatGroupAdd, Log
  },
  methods: {
    show(agentItemId, title) {
      this.agentItemId = agentItemId
      this.inputTitle = title
      this.isVisible = true
      this.messages = [];
      this.viewType = 'chat'
      this.getAgentInfo()
      this.getChatGroup()

    },

    getAgentInfo: function () {
      let that = this;
      this.$post(
          {
            context: that,
            path: '/agent/info/',
            params: {
              item_id: this.agentItemId
            },
            success: function (data) {
              that.agent = data.agent;
              if (data.agent.welcome) {
                const newMessage = {
                  id: that.messages.length + 1,
                  type: 'other',
                  content: data.agent.welcome,
                  avatar: 'https://cdn.haohuatech.cn/20241111/bd1d3135e571e0b9024e491e5589b60a-731293799623406342.jpeg'
                };
                that.messages.push(newMessage);
              }
            }
          }
      )
    },

    getChatGroup: function () {
      let that = this;
      this.$post(
          {
            context: that,
            path: '/aigc/chat_group/list/',
            params: {
              agent_id: this.agentItemId
            },
            success: function (data) {
              that.chat_groups = data.items;
              if (data.items.length > 0) {
                that.chat_group_id = data.items[data.items.length - 1].itemId
                that.chat_group_title = data.items[data.items.length - 1].title
                that.messages = []
                //that.viewType = "chat"
                that.loadHistoryItems()
              }
            }
          }
      )
    },

    changeGroup(e) {
      this.messages = []
      this.chat_group_id = e.itemId;
      this.chat_group_title = e.title
      this.loadHistoryItems()
      //this.viewType = "chat"
    },

    loadHistoryItems() {
      let t = this;
      this.$post(
          {
            context: t,
            loading: true,
            path: '/aigc/log/list/',
            params: {
              type: 2301,
              agent_id: this.agentItemId || 0,
              group_id: this.chat_group_id || 0
            },
            success: function (data) {
              console.log(data.logs)
              let logs = data.logs.reverse()
              logs.forEach(item => {
                {
                  let content = item.param.prompt
                  if(item.param.file){
                    let files = item.param.file.split(",");
                    files.forEach(item=>{
                      content +="\n![图片]("+item+")";
                    })
                  }
                  const newMessage = {
                    id: t.messages.length + 1,
                    type: 'me',
                    content: content,
                    avatar: 'https://cdn.haohuatech.cn/20241111/29b445fcaf9d940b0e6a70586c9c2eb5-731293763407773743.jpeg'
                  };
                  t.messages.push(newMessage);
                }

                {
                  const newMessage = {
                    id: t.messages.length + 1,
                    type: 'other',
                    'content': item.data.data[0],
                    avatar: 'https://cdn.haohuatech.cn/20241111/bd1d3135e571e0b9024e491e5589b60a-731293799623406342.jpeg'
                  };
                  t.messages.push(newMessage);
                }
                t.scrollToBottom()

              })
            }
          }
      )
    },

    handleTabClick(e) {
      console.log(e)
      if (e === 'log') {
        this.$refs.log.init(2301, this.agentItemId, this.chat_group_id)
      }
    },
    changeAgent(e) {
      this.agentItemId = e;
    },

    templateAction() {
      this.$refs.templatePick.init(this.agent.template);
    },
    templateInfo(e) {
      this.inputValue = e
    },

    createChatGroup() {
      //this.$refs.chatGroupAdd.init(this.agentItemId)
      this.messages = []
      let t = this;
      this.$post(
          {
            context: t,
            loading: true,
            path: '/aigc/chat_group/add/',
            params: {
              title: '新对话',
              agent_id: this.agentItemId
            },
            success: function (data) {
              t.getChatGroup()
            }
          }
      )
    },

    onScrollToLower() {
      // 处理滚动到底部的逻辑
      console.log('滚动到底部');
    },
    onInput(event) {
      // 处理输入框输入的逻辑
      this.inputValue = event.target.value;
    },

    copy(content) {
      try {
        navigator.clipboard.writeText(content);
        this.$message({
          type: 'success',
          message: '复制成功!'
        });
      } catch (err) {
      }
    },


    fileUploadSuccess(e, name) {
      //this.sendMessageMe(name)
      //this.getAiData(name, e)

      console.log(e)
      this.file_urls.push({name: name, url: e})
    },

    deleteFileUrl(index) {
      this.file_urls.splice(index, 1)
    },


    sendMessageMe(content) {
      const newMessage = {
        id: this.messages.length + 1,
        type: 'me',
        content,
        avatar: 'https://cdn.haohuatech.cn/20241111/29b445fcaf9d940b0e6a70586c9c2eb5-731293763407773743.jpeg'
      };
      this.messages.push(newMessage);
      this.inputValue = '';
      this.scrollToBottom();
      if (this.chat_group_title === '新对话') {

        this.$get(
            {
              context: this,
              loading: true,
              path: '/aigc/chat_group/title_update/',
              params: {
                title: content,
                item_id: this.chat_group_id
              },
              success: function (data) {

              }
            }
        )
      }
    },


    sendMessage() {

      let token = localStorage.getItem("token");
      if (!token) {
        console.log('未登陆')
        this.$emit("checkLogin");
        return;
      }

      const content = this.inputValue.trim();
      if (content) {
        // const newMessage = {
        //   id: this.messages.length + 1,
        //   type: 'me',
        //   content,
        //   avatar: 'https://cdn.haohuatech.cn/20241111/29b445fcaf9d940b0e6a70586c9c2eb5-731293763407773743.jpeg'
        // };
        // this.messages.push(newMessage);
        // this.inputValue = '';
        // this.scrollToBottom();

        this.sendMessageMe(content)
        this.getAiData(content, "")
      }
    },


    scrollToBottom() {
      const messageList = this.$refs.messageList;
      //console.log(messageList.scrollHeight)
      messageList.scrollTop = messageList.scrollHeight;
    },


    startRecording() {
      this.recording = true
      this.recorder = new Recorder({sampleRate: 16000})
      Recorder.getPermission().then(() => {
        console.log('开始录音')
        this.recorder.start() // 开始录音
      }, (error) => {
        //Toast.fail(`获取麦克风失败：${error}`)
        console.log(`获取麦克风失败：${error}`)
      })
    },
    // 停止录音
    stopRecording() {
      this.recording = false
      this.recorder.stop() // 停止录音
      this.sendAudioData();
    },
    async sendAudioData() {
      if (this.recorder == null || this.recorder.duration === 0) {
        return false
      }
      this.recorder.pause()
      console.log('上传录音')
      const blob = this.recorder.getWAVBlob()
      console.log('blob', blob);
      //const newbolb = new Blob([blob], { type: 'audio/wav' })

      let t = this
      const formDataFile = new FormData()
      formDataFile.append('file', blob)

      this.$postFile(
          {
            context: t,
            loading: false,
            path: '/aigc/voice/voice_2_text/',
            params: formDataFile,
            success: function (data) {
              console.log(data)

              // const newMessage = {
              //   id: t.messages.length + 1,
              //   type: 'me',
              //   content: data.text,
              //   avatar: 'https://cdn.haohuatech.cn/20241111/29b445fcaf9d940b0e6a70586c9c2eb5-731293763407773743.jpeg'
              // };
              // t.messages.push(newMessage);
              // t.inputValue = '';
              // t.scrollToBottom();

              t.sendMessageMe(data.text)
              t.getAiData(data.text, '')
            },
            error: function () {
            }
          }
      )
    },


    // fileUploadSuccess(e) {
    //   this.fileUrl = e;
    //   this.inputData = '上传文件'
    //   this.getAiData()
    // },

    //===========数据调用==============//
    getAiData(text, fileUrl) {
      let t = this

      if (this.file_urls) {
        const urls = [];
        this.file_urls.forEach(item => {
          urls.push(item.url)
        })
        fileUrl = urls.join(",");
      }

      console.log(this.file_urls)
      if (this.agent.params) {
        //console.log(this.agent.params);
        text = JSON.stringify(this.agent.params)
        fileUrl = ""
      }

      const isProduction = process.env.NODE_ENV === 'production'
      let url = "" + (isProduction ? this.$chatHost : "http://localhost:55001") + "/aigc/text/create/?prompt=" + encodeURIComponent(text) + "&agent_item_id=" + this.agentItemId + "&chat_group_id=" + this.chat_group_id + "&file_url=" + encodeURIComponent(fileUrl) + "&platform=1&user_id=" + localStorage.getItem('userId') + "&token=" + localStorage.getItem('token');

      const newMessage = {
        id: this.messages.length + 1,
        type: 'other',
        'content': '',
        avatar: 'https://cdn.haohuatech.cn/20241111/bd1d3135e571e0b9024e491e5589b60a-731293799623406342.jpeg'
      };
      this.messages.push(newMessage);
      this.file_urls = [];


      this.isStream = true

      let w = ''
      const eventSource = new EventSource(url);
      this.eventSource = eventSource;

      //eventSource.timeout = 6000000
      eventSource.onopen = function (e) {
        console.log("连接打开 " + new Date());
      };
      eventSource.onmessage = function (e) {
        let data = e.data.replace(/\\x0A/g, '\n');
        w = w + data;
        newMessage.content = w
        t.scrollToBottom();
      };
      eventSource.onerror = function (e) {
        eventSource.close(); // 关闭连接
        console.log(e)
        console.log("连接关闭");
        t.isStream = false
      };

      this.inputData = "";

    },

    stopStream() {
      this.isStream = false;
      if (this.eventSource) {
        this.eventSource.close()
      }
    },


    handleClick(event) {
      // 检查事件目标是否是一个链接
      const target = event.target.closest('a');
      console.log("open:" + target)
      if (target && (target.href.startsWith('http://') || target.href.startsWith('https://')) && target.href.indexOf('item_id=') !== -1) {
        event.preventDefault();

        //const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig;
        //const urls = target.toString().match(urlRegex);
        //console.log(urls[0])
        const params = this.parseUrlParams(target.href);
        console.log(params)
        //console.log("kkk"+params.jobid)
        //this.$router.push({ path: '/detail?jobId='+params.jobid });

        if (this.checkEnvironment()) {
          // wx.miniProgram.postMessage({
          //   data: {
          //     type: 'product_display',
          //     data: { item_id: params.item_id }
          //   }
          // });
          // wx.miniProgram.navigateTo({
          //   'url':'/pages/index/index'
          // });

          wx.miniProgram.showToast({
            title: '这是一个提示框',
            icon: 'none',
            duration: 2000
          });
        } else {
          this.$refs.productDisplay.init(params.item_id)
        }
      }
    },

    parseUrlParams(url) {
      const params = {};
      const reg = /(?:\?|&)([^=]+)=([^&]+)/g;
      let match;
      while (match = reg.exec(url)) {
        const key = decodeURIComponent(match[1]);
        const value = decodeURIComponent(match[2]);
        if (!params.hasOwnProperty(key)) {
          params[key] = value;
        } else if (Array.isArray(params[key])) {
          params[key].push(value);
        } else {
          params[key] = [params[key], value];
        }
      }
      return params;
    },


    checkEnvironment() {
      console.log(wx + "ddd")
      console.log(wx.getSystemInfo + "   kkk")
      if (typeof wx !== 'undefined' && wx.getSystemInfo) {
        return true;
      } else if (typeof WeixinJSBridge !== 'undefined') {
        return false;
      } else {
        return false;
      }
    }

  }

}
</script>

<style scoped>
@import '../../assets/global.css';

.chat-container {
  display: flex;
  flex-direction: column;
  height: 470px;
}

/*.message-list {*/
/*  flex: 1;*/
/*  overflow: auto;*/
/*  padding: 5px;*/
/*  background-color: #f5f5f5;*/
/*  padding-bottom: 100px;*/
/*}*/

.message-list {
  flex: 1;
  overflow: auto;
  padding: 15px;
  background-color: #fcfcfc;
  min-height: 400px;
  max-height: 400px;


}

.message {
  display: flex;
  align-items: flex-end;
  margin-bottom: 10px;
}

.mine {
  justify-content: flex-end;
  align-items: flex-start;
}

.other {
  justify-content: flex-start;
  align-items: flex-start;
  margin-right: 10px;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}

.content {
  max-width: 90%;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 10px;
  background-color: #fff;
  word-wrap: break-word;
  border: 1px solid #f8f8f8;
  color: black;
}

.input-container {
  display: flex;
  width: 98%;
  align-items: center;
  padding: 10px;
  position: absolute;
  left: 0;
  bottom: 0;
  background-color: #fff;
  box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.1);
}

.input {
  width: 55%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 20px;
  margin-right: 10px;
  margin-left: 10px;
}

.send-button, .record-button {
  padding: 10px 20px;
  /*background-color: #1aad19;*/
  background: #765bea;
  color: #fff;
  border: none;
  margin-left: 5px;
  border-radius: 10px;
  font-size: 16px;
}


.record-stop-button {
  padding: 10px 20px;
  background-color: #a580c7;
  color: #e8e8e8;
  border: none;
  margin-left: 5px;
  border-radius: 10px;
  font-size: 16px;
}


</style>
